import { IReduxStore } from "Redux/Store/IReduxStore";

export const getFileReferenceCount = (state: IReduxStore) =>
    state.fileReference.fileReference.maxCount;
